<template>
  <div>
    <v-card class="grid_line_first" elevation="6">
      <div class="ma-3">
        <div class="pa-3">
          <div class="grid_header_dairy">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_dairy" :src="img_dairy"/>
            </div>
            <div class="pt-2 pl-2" style="font-size: 28px"><b>ภารกิจประจำวัน</b></div>
          </div>
        </div>
        <div v-if="loading_dairy_quests === true">
          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <div v-else class="grid_four">
          <div class="ma-3">
            <v-card elevation="3" @click="expired_page">
              <div class="pa-3">
                <div class="font_dairy"><b>จำนวนสินค้าใกล้หมดอายุ</b></div>
                <div class="grid_count mt-2">
                  <div class="mx-auto">
                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_all_new" :src="img_all_new"/>
                  </div>
                  <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(expired_qty) }}</b></div>
                </div>
              </div>
            </v-card>
          </div>
          <div class="ma-3">
            <v-card elevation="3" @click="order_page">
              <div class="pa-3">
                <div class="font_dairy"><b>จำนวนคำสั่งซื้อที่กำลังดำเนินการทั้งหมด</b></div>
                <div class="grid_count mt-2">
                  <div class="mx-auto">
                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_in_complete" :src="img_in_complete"/>
                  </div>
                  <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(order_in_progress) }}</b></div>
                </div>
              </div>
            </v-card>
          </div>
          <div class="ma-3">
            <v-card elevation="3" @click="refunds_page">
              <div class="pa-3">
                <div class="font_dairy"><b>จำนวนการคืนสินค้าจากลูกค้า</b></div>
                <div class="grid_count mt-2">
                  <div class="mx-auto">
                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="new_customer" :src="new_customer"/>
                  </div>
                  <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(refunds) }}</b></div>
                </div>
              </div>
            </v-card>
          </div>
          <div class="ma-3">
            <v-card elevation="3" @click="potential_page">
              <div class="pa-3">
                <div class="font_dairy"><b>รายการคลังที่ต้องมีการตรวจสอบ</b></div>
                <div class="grid_count mt-2">
                  <div class="mx-auto">
                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_search" :src="img_search"/>
                  </div>
                  <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(approve) }}</b></div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import {formatNumber} from "@/js/handler";
import img_dairy from "@/assets/flag_refund.png";
import img_all_new from "@/assets/note_refund.png";
import img_in_complete from "@/assets/procurement_refund.png";
import new_customer from "@/assets/new_customer.png";
import img_search from "@/assets/search_refund.png";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Dairy_quests",
  data() {
    return {
      loading_dairy_quests: false,
      img_dairy: img_dairy,
      img_all_new: img_all_new,
      img_in_complete: img_in_complete,
      new_customer: new_customer,
      img_search: img_search,
      expired_qty: 0,
      order_in_progress: 0,
      approve: 0,
      refunds: 0,
    }
  },
  methods:  {
    format_number: function (value) {
      return formatNumber(value)
    },
    get_data() {
      HTTP.post('dashboards/dairymission')
          .then((res) => {
            if(res.data.success === true) {
              this.expired_qty = res.data.expired
              this.order_in_progress = res.data.orderinprogress
              this.approve = res.data.approve
              this.refunds = res.data.refunds
            }
          })
    },
    expired_page() {
      this.$router.push('/stock/storage/expstorage')
    },
    order_page() {
      this.$router.push('/sell/orderretailcustomers')
    },
    refunds_page() {
      this.$router.push('/refund/refundwaitforprocess')
    },
    potential_page() {
      this.$router.push('/stock/verifymain')
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_line_first {
  display: grid;
  grid-template-columns: 100%;
}
.grid_header_dairy {
  display: grid;
  grid-template-columns: 8% 92%;
}
.grid_count {
  display: grid;
  grid-template-columns: 25% 75%;
}
.grid_four {
  display: grid;
  grid-template-columns: 20% 30% 25% 25%;
  grid-gap: 15px 0;
}
.font_dairy {
  font-size: 20px !important;
}
@media only screen and (max-width: 1180px) {
  .grid_header_dairy {
    display: grid;
    grid-template-columns: 15% 85%;
  }
  .grid_four {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 0 0;
  }
  .font_dairy {
    font-size: 18px !important;
  }
}
@media only screen and (max-width: 500px) {
  .grid_header_dairy {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_four {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 0 0;
  }
  .font_dairy {
    font-size: 16px !important;
  }
}
</style>
